<template>
  <v-card flat color="transparent">
    <v-card-text class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">基本情報</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="modified" rounded depressed small @click="onRefresh()">
              <span class="text-none">中止</span>
            </v-btn>
            <v-btn v-if="type == 'create'" dark rounded depressed small color="error" @click.native="onUpdateDialog()">
              <span class="text-none">作成</span>
            </v-btn>
            <v-btn v-else-if="type == 'edit' && modified" dark rounded depressed small color="error" @click.native="onUpdateDialog()">
              <span class="text-none">更新</span>
            </v-btn>
          </v-toolbar>
        </v-col>
      </v-row>

      <v-sheet v-if="myItem" class="overflow-y-auto" :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="6" class="py-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="1" class="pa-0"></v-col>
                  <v-col cols="3" class="pa-0">
                    <v-avatar-selector
                      v-model="file"
                      :previewSize="80"
                      :tile="false"
                      :url="getProfileImage()"
                      :enable="type != 'view'"
                      :icon="'mdi-image-plus'"
                    >
                    </v-avatar-selector>
                  </v-col>
                  <v-col class="pa-0">
                    <v-btn v-if="!checkAvatar()" dark rounded depressed x-small color="error" @click="onAvatarReset()">
                      <span class="px-1 text-none">初期化</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="pa-0">
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="8" class="pa-0">
                <v-text-field
                  ref="school"
                  label="塾名称"
                  v-model="myItem.name"
                  :rules="[rules.required]"
                  :disabled="type == 'view'"
                  class="title"
                  @change="modified = true"
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="pa-0">
                <v-text-field
                  ref="id"
                  prepend-icon="mdi-security"
                  name="ID"
                  label="利用者登録ID"
                  placeholder="1234567890"
                  v-model="myItem.id"
                  type="text"
                  class="title"
                  readonly
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="3" class="pa-0">
                <v-text-field
                  ref="zip"
                  v-model="myItem.zip"
                  label="*郵便番号"
                  required
                  append-outer-icon="search"
                  type="text"
                  @click:append-outer="onSearch()"
                  @keyup.enter.native="onSearch()"
                  :disabled="type == 'view'"
                  @change="modified = true"
                ></v-text-field>
              </v-col>
              <v-col cols="9" class="pa-0">
                <v-text-field
                  ref="address"
                  v-model="myItem.address"
                  label="住所"
                  required
                  class="pr-1"
                  :disabled="type == 'view'"
                  @change="modified = true"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="pa-0"></v-col>
              <v-col cols="9" class="pa-0">
                <v-text-field
                  ref="address2"
                  v-model="myItem.address2"
                  label="住所（番地・建屋名称・部屋番号）"
                  :disabled="type == 'view'"
                  @change="modified = true"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="4" class="pa-0">
                <v-text-field
                  ref="fixed"
                  prepend-icon="mdi-phone-classic"
                  v-model="myItem.phone"
                  label="電話"
                  class="mr-1"
                  :disabled="type == 'view'"
                  @change="modified = true"
                ></v-text-field>
              </v-col>
              <v-col cols="8" class="pa-0">
                <v-text-field
                  ref="email"
                  prepend-icon="mdi-email"
                  v-model="myItem.email"
                  :rules="[rules.email]"
                  label="Email"
                  :disabled="type == 'view'"
                  @change="modified = true"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="4" class="pa-0"></v-col>
              <v-col cols="8" class="pa-0">
                <v-text-field
                  ref="web"
                  prepend-icon="mdi-web"
                  v-model="myItem.web"
                  :rules="[rules.url]"
                  label="HP"
                  :disabled="type == 'view'"
                  @change="modified = true"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <template v-if="data && getPrivilegesLevel(data) <= 1">
            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">経営哲学</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small icon @click.stop.prevent="expandPolicy = !expandPolicy">
                  <v-icon v-if="expandPolicy">mdi-chevron-up</v-icon>
                  <v-icon v-else>mdi-chevron-down</v-icon>
                </v-btn>
              </v-toolbar>
            </v-col>
            <v-col cols="12">
              <template-policy v-if="expandPolicy" :item="myItem" :type="'edit'" @change="onFilePicked" @modified="onChange" @imageReset="onImageReset" :policyImageFile="policyImageFile"></template-policy>
            </v-col>

            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">機能</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="9" class="pa-0">
                  <span>経営哲学をホーム画面へ</span><span class="primary--text font-weight-bold">{{ myItem.popup ? ' 表示' : ' 非表示' }}</span>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.popup"
                    color="primary"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="9" class="pa-0">
                  <span>伝言</span><span class="primary--text font-weight-bold">{{ myItem.public ? ' 公開' : ' 非公開' }}</span>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.public"
                    color="primary"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="9" class="pa-0">
                  <span>生徒アイコン表示</span><span class="primary--text font-weight-bold">{{ myItem.studentsIcon ? ' 有効' : ' 無効' }}</span>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.studentsIcon"
                    color="primary"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <!-- <v-col v-if="data && getPrivilegesLevel(data) == 0" cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="9" class="pa-0">
                  <span>幼児サポート</span><span class="error--text font-weight-bold">{{ myItem.preschool ? ' 有効' : ' 無効' }}</span>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.preschool"
                    color="error"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
                <v-col v-if="myItem.preschool" cols="12" class="pa-0">
                  <v-row class="ma-0 pa-0" align="center">
                    <v-col cols="1" class="pa-0"></v-col>
                    <v-col cols="9" class="pa-0">
                      <span class="red--text">拡張（注）フリーウィルサーバでは変更厳禁</span>
                    </v-col>
                    <v-col cols="1" class="pa-0">
                      <v-text-field
                        v-model.number="myItem.extension"
                        required
                        :rules="[rules.extensionCheck]"
                        @change="modified = true"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col> -->
            <v-col v-if="getPrivilegesLevel(data) == 0" cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="9" class="pa-0">
                  <span class="red--text">塾</span><span class="red--text font-weight-bold">{{ myItem.enable ? ' 有効' : ' 無効' }}</span>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.enable"
                    color="error"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">要アクション設定</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="6" class="pa-0">
                  <span>誕生日</span><span class="primary--text font-weight-bold">{{ myItem.actions.birth ? ' 表示' : ' 非表示' }}</span>
                </v-col>
                <v-col cols="3" class="pb-0">
                  <v-text-field
                    label="範囲（1 - 30）"
                    v-model.number="myItem.actions.birthSpan"
                    suffix="日以内"
                    required
                    :rules="[rules.numCheck]"
                    @change="modified = true"
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.actions.birth"
                    color="primary"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="6" class="pa-0">
                  <span>DTS</span><span class="primary--text font-weight-bold">{{ myItem.actions.dts ? ' 表示' : ' 非表示' }}</span>
                </v-col>
                <v-col cols="3" class="py-0">
                  <v-text-field
                    label="範囲（1 - 30）"
                    v-model.number="myItem.actions.dtsSpan"
                    suffix="日経過"
                    required
                    :rules="[rules.numCheck]"
                    @change="modified = true"
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.actions.dts"
                    color="primary"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="6" class="pa-0">
                  <span>YCS</span><span class="primary--text font-weight-bold">{{ myItem.actions.ycs ? ' 表示' : ' 非表示' }}</span>
                </v-col>
                <v-col cols="3" class="py-0">
                  <v-select
                    :items="$YCSS"
                    label="YCS"
                    v-model="myItem.actions.ycsLevel"
                    suffix="以下"
                    :rules="[rules.required]"
                    item-text="name"
                    item-value="key"
                    @change="modified = true"
                  ></v-select>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.actions.ycs"
                    color="primary"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">新規生徒</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="6" class="pa-0">
                  <span>進捗警告</span>
                </v-col>
                <v-col cols="3" class="pb-0">
                  <v-text-field
                    label="経過（1 - 14）"
                    v-model.number="myItem.newbee.span"
                    suffix="日経過"
                    required
                    :rules="[rules.spanCheck]"
                    @change="modified = true"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">タスク設定</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="6" class="pa-0">
                  <span>表示期間</span>
                </v-col>
                <v-col cols="3" class="pb-0">
                  <v-text-field
                    label="締切後経過（1 - 14）"
                    v-model.number="myItem.tasks.span"
                    suffix="日以内"
                    required
                    :rules="[rules.spanCheck]"
                    @change="modified = true"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">アクセス制限（講師）</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="9" class="pa-0">
                  <span>計画（タスク・イベント）閲覧</span><span :class="myItem.privileges.plan ? 'primary--text font-weight-bold' : 'error--text font-weight-bold'">{{ myItem.privileges.plan ? ' 許可' : ' 禁止' }}</span>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.privileges.plan"
                    color="primary"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="9" class="pa-0">
                  <span>生徒情報（新規・変更・削除）</span><span :class="myItem.privileges.edit ? 'primary--text font-weight-bold' : 'error--text font-weight-bold'">{{ myItem.privileges.edit ? ' 許可' : ' 禁止' }}</span>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="myItem.privileges.edit"
                    color="primary"
                    :disabled="type == 'view'"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-sheet>
    </v-card-text>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div v-if="myItem">
      <app-basic-dialog
        @dismissed="onDismissed"
        :title="myItem.key ? '更新' : '新規'"
        message='新たに塾を作成します。よろしいですか？'
        :dialog='updateDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

  </v-card>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TemplatePolicy from '../../components/school/TemplatePolicy.vue'
Vue.component('template-policy', TemplatePolicy)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      windowSize: 'shared/windowSize'
    })
  },
  props: [ 'item', 'dialog', 'type', 'contentsHeight' ],
  data () {
    return {
      modified: false,
      expandPolicy: false,
      updateDialog: false,
      checkbox: true,
      loading: false,
      myItem: null,
      file: null,
      policyImageFile: null,
      url: null,
      rules: {
        required: value => !!value || 'Required.',
        // name: v => this.checkName() || 'Required',
        email: value => {
          if (value) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
          return false
        },
        url: value => {
          if (value) {
            // eslint-disable-next-line
            const pattern = /^(ftp|http|https):\/\/(([a-zA-Z0-9$\-_.+!*'(),;:&=]|%[0-9a-fA-F]{2})+@)?(((25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])){3})|localhost|([a-zA-Z0-9\-\u00C0-\u017F]+\.)+([a-zA-Z]{2,}))(:[0-9]+)?(\/(([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*(\/([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*)*)?(\?([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?(\#([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?)?$/
            return pattern.test(value) || 'Invalid URL.'
          }
          return false
        },
        numCheck: value => {
          var pattern = /^[0-9]*$/
          if (!pattern.test(value)) {
            return '無効な値です'
          }
          return (value > 0 && value < 31) || '範囲を超えています'
        },
        spanCheck: value => {
          return (value > 0 && value < 15) || '範囲を超えています'
        },
        extensionCheck: value => {
          return (value >= 0 && value <= 1) || '範囲を超えています'
        }
      },
      birthRange: 7
    }
  },
  watch: {
    file () {
      if (this.file !== null) {
        this.modified = true
      }
    },
    policyImageFile () {
      if (this.policyImageFile !== null) {
        this.modified = true
      }
    },
    item () {
      this.myItem = JSON.parse(JSON.stringify(this.item))
    }
  },
  created () {
    this.myItem = JSON.parse(JSON.stringify(this.item))
    if (typeof this.myItem.privileges === 'undefined') {
      Vue.set(this.myItem, 'privileges', {
        plan: true,
        edit: true,
        view: true
      })
    }
    if (typeof this.myItem.actions === 'undefined') {
      Vue.set(this.myItem, 'actions', {
        birth: false,
        birthSpan: 14,
        ycs: false,
        ycsLevel: 3,
        dts: false,
        dtsSpan: 14
      })
    }
    if (typeof this.myItem.tasks === 'undefined') {
      Vue.set(this.myItem, 'tasks', {
        span: 7
      })
    }
    if (typeof this.myItem.newbee === 'undefined') {
      Vue.set(this.myItem, 'newbee', {
        span: 7
      })
    }
  },
  methods: {
    getProfileImage () {
      if (this.myItem) {
        if (this.myItem.avatar) {
          return this.myItem.avatar.thumbnail
        }
      }
      return ''
    },
    checkAvatar () {
      if (this.type === 'view') {
        return true
      }
      if (!this.myItem) {
        return true
      }
      if (this.myItem.avatar) {
        return this.myItem.avatar.path === this.user.photoURL
      }
      return true
    },
    onAvatarReset () {
      this.file = null
      this.myItem.avatar = null
      this.modified = true
    },
    onImageReset () {
      this.policyImageFile = null
      this.myItem.policyImage = null
      this.modified = true
    },
    onChange () {
      this.modified = true
    },
    onFilePicked: function (value) {
      this.policyImageFile = value.file
      this.modified = true
    },
    onClose () {
      this.$emit('dismissed')
    },
    onUpdateDialog () {
      if (this.$refs.school.validate(true)) {
        this.updateDialog = true
      }
    },
    onUpdate () {
      var vm = this
      var payload = null
      vm.loading = true
      payload = JSON.parse(JSON.stringify(this.myItem))
      payload['updatedAt'] = parseInt(new Date().getTime())
      if (payload.key === null) {
        payload['createdAt'] = parseInt(new Date().getTime())
      }
      this.$store.dispatch('schools/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
        var p1 = new Promise(function (resolve, reject) {
          if (vm.file) {
            vm.$store.dispatch('storage/write', { blob: vm.file, child: 'schools', id: resp, uuid: vm.genUUIDv4() }).then(() => {
              vm.file = null
              resolve()
            })
          } else {
            resolve()
          }
        })
        var p2 = new Promise(function (resolve, reject) {
          if (vm.policyImageFile) {
            vm.$store.dispatch('storage/write', { blob: vm.policyImageFile, child: 'policy', id: resp, uuid: vm.genUUIDv4() }).then(() => {
              vm.policyImageFile = null

              resolve()
            })
          } else {
            resolve()
          }
        })
        Promise.all([p1, p2]).then(function () {
          vm.modified = false
          vm.loading = false
          vm.$emit('dismissed')
        })
      })
    },
    onSearch () {
      var vm = this
      if (this.myItem.zip === '' || this.myItem.zip.length < 7) {
        return
      }
      this.loading = true
      var payload = this.myItem.zip
      this.$store.dispatch('postcode/search', payload).then(function (data) {
        if (data) {
          vm.myItem.address = data.val().a7
        } else {
          vm.myItem.address = null
          vm.myItem.address2 = null
        }
        vm.loading = false
      })
    },
    onDismissed: function (result) {
      this.updateDialog = false
      if (result) {
        this.$nextTick(function () {
          this.onUpdate()
        })
      }
    },
    onRefresh () {
      this.file = null
      this.policyImageFile = null
      this.myItem = JSON.parse(JSON.stringify(this.item))
      if (typeof this.myItem.actions === 'undefined') {
        Vue.set(this.myItem, 'actions', {
          birth: false,
          birthSpan: 14,
          ycs: false,
          ycsLevel: 3,
          dts: false,
          dtsSpan: 14
        })
      }
      if (typeof this.myItem.tasks === 'undefined') {
        Vue.set(this.myItem, 'tasks', {
          span: 7
        })
      }
      this.modified = false
    }
  }
}
</script>

<style scoped>
 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}
</style>
